<template lang="pug">
  #contact
    section.banner.position-relative
        div.picture
            img.img-fluid.big(src="img/banner/banner_contact.jpg" alt="banner-contact")
            img.img-fluid.small(src="img/banner/banner_contact_mobile.jpg" alt="banner-contact")
        div.mask_banner
        div.breadcrumb_block
            b-container
                b-breadcrumb(:items="breadcrumb_items")
        div.banner_h1
            h1 聯絡我們
    b-container.py-5
        div.slogan
            p.text-center.font-weight-bolder.py-0.py-md-5 歡迎造訪本公司網站，我們非常歡迎您進一步產品相關諮詢，請您與我們聯絡討論服務細節。
        hr.d-none.d-md-block
        b-row.my-4.my-md-5#info.mx-auto.align-items-center
            b-col(cols="12" md="2").text-md-center.text-left.divider_top
                svg(viewbox="0 0 82 82" fill="#5B9ECB").info_svg
                    path(d="M80.3782377,77.3271106 C79.3673317,76.7383019 73.2123684,72.9262622 69.9192364,66.0338689 C77.610418,58.8413049 81.9849248,48.8355617 81.9849248,38.5954803 C81.9849248,17.4025322 63.507863,0 40.9924624,0 C18.4770618,0 0,17.4025322 0,38.5954803 C0,59.7884284 18.4770618,77.1909606 40.9924624,77.1909606 C44.0149304,77.1909606 47.2614569,76.9076084 51.7407058,75.9664115 C63.5134684,82.2229042 74.0802549,82.0470305 78.1006562,81.9836006 C79.8904018,81.9613361 81.1897492,82.2845722 81.8584013,80.4353349 C82.3110028,79.1949284 81.6415498,77.7621499 80.3782377,77.3271106 Z M45.7963479,57.9733087 C45.7963479,60.6264716 43.6456101,62.7778017 40.9924624,62.7778017 C38.3393146,62.7778017 36.1885769,60.6264716 36.1885769,57.9733087 L36.1885769,38.5954803 C36.1885769,35.941997 38.3393146,33.7909872 40.9924624,33.7909872 C43.6456101,33.7909872 45.7963479,35.941997 45.7963479,38.5954803 L45.7963479,57.9733087 Z M40.9924624,26.4243114 C38.3393146,26.4243114 36.1885769,24.2729813 36.1885769,21.6198184 C36.1885769,18.966335 38.3393146,16.8153253 40.9924624,16.8153253 C43.6456101,16.8153253 45.7963479,18.966335 45.7963479,21.6198184 C45.7963479,24.2731415 43.6456101,26.4243114 40.9924624,26.4243114 Z")
            b-col(cols="12" md="auto").text-md-center.text-left.pb-3.pb-md-0
                div.pb-3
                    a.pb-4 電話:+886-2-27178211
                div 傳真:+886-2-27178393
            b-col(cols="12" md="6").text-md-center.text-left
                div.pb-3
                    b-icon(icon="envelope")
                    a(href="mailto:frank77511ya@npc.com.tw").pl-2 frank77511ya@npc.com.tw
                div
                address.m-0 台北市內湖區南京東路六段380號(A1棟)
        hr
    section.bgc_second
        b-container.py-5 
            p.text-center / 歡迎來信諮詢或索取樣品，我們將盡快與您聯繫，並提供最優質的服務。/
            div
                b-form.m-auto.py-5(v-if="show" name="aForm"  method="post" action="sendmail.asp")
                    b-row
                        b-col(cols="12" md="7")
                            b-form-group(id="input-group-1" label="選擇聯絡性質*" label-for="input-1")
                                b-form-select(id="input-1" v-model="form.property" :options="property" required name="ContactSubject")
                        b-col(cols="12" md="5")
                            b-form-group(id="input-group-2" label="諮詢商品" label-for="input-2")
                                b-form-select(id="input-2" v-model="form.goods" :options="goods" required name="ContactProduct")
                        b-col.pt-4(cols="12")
                            b-form-group(id="input-group-3" label="姓名*" label-for="input-3")
                                b-form-input(id="input-3" v-model="form.name" required  name="ContactName")
                        b-col.pt-4(cols="12")
                            b-form-group(id="input-group-4" label="EMAIL*" label-for="input-4")
                                b-form-input(id="input-4" v-model="form.email" required name="ContactEmail")
                        b-col.pt-4(cols="12")
                            b-form-group(id="input-group-5" label="聯絡電話*" label-for="input-5")
                                b-form-input(id="input-5" v-model="form.phone" required name="ContactPhone")
                        b-col.pt-4(cols="12")
                            b-form-group(id="input-group-6" label="你的留言" label-for="input-6")
                                b-form-textarea(id="textarea" v-model="form.message" rows="6" max-rows="10" required name="ContactText")
                        b-col#verify.pt-4.pb-5(cols="12")
                            b-form-group(id="input-group-7" label="驗證碼*" label-for="input-7")
                                b-form-input(id="input-7" v-model="form.vefifylabel" required name="verifycode")
                            .col-sm-2
                                #checkCode.code
                                .refresh( @click="createCode")
                        b-col.text-center(cols="12")
                            b-button( @click="onSubmit" variant="link") 寄出
                                svg(viewbox="0 0 32 30")
                                    line(x1=0 y1=20 x2=30 y2=20)
                                    line(x1=30 y1=20 x2=16 y2=8)
</template>

<script>
export default {
    metaInfo: {
        title: '聯絡我們-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: '歡迎造訪本公司網站，我們非常歡迎您進一步產品相關諮詢，請您與我們聯絡討論服務細節。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、聯絡我們。' },
            { name: 'og:title', content: '聯絡我們-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: '歡迎造訪本公司網站，我們非常歡迎您進一步產品相關諮詢，請您與我們聯絡討論服務細節。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: 'Home',
                    to: { name: 'App' }
                },
                {
                    text: '聯絡我們',
                    active: true
                }
            ],
            form: {
                email: '',
                name: '',
                email: '',
                phone: '',
                message: '',
                property: null,
                goods: null
                },
            property: [
                    { text: '請選取內容', value: null },
                    { text: '產品諮詢', value: '產品諮詢' },
                    { text: '樣品索取', value: '樣品索取' },
                    { text: '其    他', value: '其他' }
                ],
            goods: [
                    { text: '請選取內容', value: null },
                    { text: '食藥醫療', value: '食藥醫療' },
                    { text: '抗靜電包裝', value: '抗靜電包裝' },
                    { text: '建材裝潢', value: '建材裝潢' },
                    { text: '卡片貼合', value: '卡片貼合' },
                    { text: '事務文具', value: '事務文具' },
                    { text: '水處理', value: '水處理' },
                    { text: '真空成型', value: '真空成型' },
                    { text: '折疊成型', value: '折疊成型' },
                    { text: '熱封', value: '熱封' },
                    { text: '印刷', value: '印刷' },
                    { text: '電鍍', value: '電鍍' }
                ],
            show: true,
            code:''
            }
    },

    mounted: function () {
        this.createCode();
    },
    methods: {
        onSubmit() {
            var verify;
            if (document.aForm.ContactSubject.value == '') {
				alert('請選擇「聯絡性質」！');
				document.aForm.ContactSubject.focus();
			} else if (document.aForm.ContactProduct.value == '') {
				alert('請選擇「諮詢商品」！');
				document.aForm.ContactProduct.focus();
			} else if (document.aForm.ContactName.value == '') {
				alert('請填寫「姓名」！');
				document.aForm.ContactName.focus();
			} else if (document.aForm.ContactEmail.value == '') {
				alert('請填寫「電子郵件」！');
				document.aForm.ContactEmail.focus();
			} else if (document.aForm.ContactPhone.value == '') {
				alert('請填寫「聯絡電話」！');
				document.aForm.ContactPhone.focus();
			} else if (document.aForm.ContactText.value == '') {
				alert('請填寫「留言」！');
				document.aForm.ContactText.focus();
			} else {
                verify = this.validateCode()
                if(verify !=1){
                    this.validateCode()
                }else{
                    document.cookie = 'teststr=nanya_pvc_apet_idc; max-age=600';
                    document.aForm.submit();
                }
			}
        },
        createCode() {
            this.code='';
            var codeLength = 6; //驗證碼的長度
            var checkCode = document.getElementById("checkCode");
            var codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //所有候選組成的驗證碼字符，當然也可以用中文的
            for (var i = 0; i < codeLength; i++)
            {
                var charNum = Math.floor(Math.random() * 34);
                this.code += codeChars[charNum];
            }
            if (checkCode)
            {
                checkCode.className = "code";
                checkCode.innerHTML = this.code;
            }
        },
        validateCode() {
            var inputCode = document.getElementById("input-7").value;
            if (inputCode.length <= 0)
            {
                alert("請输入驗證碼！");
                return 0;
            }
            else if (inputCode.toUpperCase() != this.code.toUpperCase())
            {
                alert("驗證碼输入有誤！");
                this.createCode();
                return 0;
            }
            else
            {
                return 1;
            }   
        }
    }
}
</script>

<style lang="sass">
.slogan p
    padding-left: 5px
    padding-right: 5px
hr
    border: solid 1px #5b9ecb

#info
    max-width: 680px
    .info_svg
        width: 82px
        height: 82px
.breadcrumb 
    background-color: transparent

.bgc_second
    .container
        padding-left: 20px
        padding-right: 20px
form
    max-width: 680px

#contact button[type="button"]
    border-radius: 3px
    background-color: #5b9ecb !important
    color: #ffffff !important
    font-size: 20px !important
    text-decoration: none !important
    // padding: 7px 40px !important
    // margin-top: 35px
    &:hover
        background-color: rgba(91, 158 , 203 ,0.65 ) !important
    
    svg
        width: 32px
        height: 30px
        stroke: #FFFFFF
        stroke-width: 2px
        stroke-linecap: round
        z-index: 2
        margin-left: 10px
        transform: scale(0.75)

.custom-select:focus 
    border-color: #5b9ecb
    box-shadow: none

.form-control:focus 
    border-color: #5b9ecb
    box-shadow: none

#input-group-1, #input-group-2
    line-height: 1.95
    letter-spacing: 1.58px
    color: #5b9ecb
    font-weight: bolder

.form-control, .custom-select
    height: calc(1.5em + 0.75rem + 20px)
    background-color: #fafafa

#input-group-3, #input-group-4, #input-group-5, #input-group-6,#input-group-7
    position: relative
    label
        position: absolute
        top: -16px
        color: rgba(0, 0, 0, 0.5)
        z-index: 2
        background-color: #fafafa
        margin-left: 15px
        padding: 0 15px
        line-height: 1.95
        letter-spacing: 1.58px
        font-weight: bolder
textarea.form-control
    padding-top: 10px
.code 
    background: url(../assets/bg_verify.jpg)
    font-family: Arial
    font-style: italic
    color: #584f34
    font-size: 20px
    border: 0
    padding: 2px 3px
    letter-spacing: 3px
    font-weight: bolder
    float: left
    width: 150px
    height: 34px
    line-height: 34px
    text-align: center
    vertical-align: middle
    margin-left: 5px
.refresh 
    background-image: url(../assets/refresh.svg)
    background-repeat: no-repeat
    width: 53px
    height: 34px
    float: left
    margin-left: 10px
    background-size: 56%
    background-position: center
    cursor: pointer
#verify > div.col-sm-2
    min-width: 248px
    padding-left: 0
@media all and ( max-width: 768px )
    #info
        .divider_top
            margin-bottom: 15px
            &::before
                content: ""
                width: 80%
                height: 2px
                background-color: #5b9ecb
                display: block
                position: absolute
                right: 0
                top: 25px
            .info_svg
                width: 41px
                height: 41px
                position: relative
                path
                    transform: scale(0.5)
</style>